import { IValueLabel } from '@/lib/shared/components/Selects/model/value-label';

import { TFunction } from 'next-i18next';

export const getTranslatedOptionsFn =
  <K>(meta: K, t: TFunction) =>
  <T extends keyof K & string>(
    options: IValueLabel[],
    query: T,
    prefix = ''
  ) => {
    return options.map((o) => {
      return {
        ...o,
        label: t(prefix + o.label),
        isDisabled:
          (meta[query]?.[o.value as keyof (typeof meta)[T]] ?? 0) === 0,
      };
    });
  };
